module.exports = __webpack_public_path__ + "static/media/logo-socrates-white.8efdaf69.svg";